// extracted by mini-css-extract-plugin
module.exports = {"analytics":"analytics-f1b89a86"};